type Accordion = {
  init: () => void;
};

const Accordion: Accordion = {
  init() {
    const accordionGroups: NodeListOf<HTMLElement> = document.querySelectorAll(
      '[data-hook=accordionGroup]',
    );
    if (!accordionGroups.length) return;

    accordionGroups?.forEach((accordionGroup) => {
      const accordionGroupItems = accordionGroup.querySelectorAll('[data-hook=accordionGroupItem]');

      accordionGroupItems?.forEach((accordionGroupItem) => {
        const accordionGroupItemButton: HTMLButtonElement | null = accordionGroupItem.querySelector(
          '[data-hook=accordionGroupItemButton]',
        );
        const accordionGroupItemPanel: HTMLElement | null = accordionGroupItem.querySelector(
          '[data-hook=accordionGroupItemPanel]',
        );

        accordionGroupItemButton?.addEventListener('click', () => {
          const newState =
            accordionGroupItemButton.getAttribute('aria-expanded') === 'true' ? 'closed' : 'open';

          accordionGroupItemButton.setAttribute(
            'aria-expanded',
            newState === 'open' ? 'true' : 'false',
          );

          accordionGroupItemPanel?.setAttribute(
            'aria-hidden',
            newState === 'open' ? 'false' : 'true',
          );
        });
      });
    });
  },
};
export default Accordion;
